import { render, staticRenderFns } from "./UserHeaderSidebar.vue?vue&type=template&id=84add026&scoped=true&"
import script from "./UserHeaderSidebar.vue?vue&type=script&lang=js&"
export * from "./UserHeaderSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserHeaderSidebar.vue?vue&type=style&index=0&id=84add026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84add026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VContainer,VList,VMenu})
